export default "__VITE_ASSET__BohexNn6__"